import { Phone } from "lucide-react";
import { PHONE_DISPLAY, TEL_HREF, CALENDLY } from "@/data/content";

export default function MobileBottomBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-white/10 md:hidden" data-testid="mobile-bottom-bar">
      <a
        href={TEL_HREF}
        data-testid="bottom-call-joe"
        className="flex items-center justify-center gap-2 bg-navy py-4 text-[12px] font-medium uppercase tracking-[0.1em] text-white"
      >
        <Phone size={15} /> Call Joe
      </a>
      <a
        href={CALENDLY}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="bottom-apply-now"
        className="flex items-center justify-center gap-2 bg-gold py-4 text-[12px] font-medium uppercase tracking-[0.1em] text-white"
      >
        Apply Now <span aria-hidden="true">→</span>
      </a>
    </div>
  );
}
